// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PegInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * AiCredits_PegInput — body for POST /ai/credits/peg.
 *
 * The GLOBAL USD-per-credit peg — layer 2 of three since 2026-08-21
 * (franchise override → this → PEG_DEFAULT). A franchise with a row in
 * ai_credit_peg_overrides does NOT use this value; see
 * AiCredits_PegOverrideInput and docs/plans/ai-credit-peg-per-franchise-plan.md.
 * D-a/D-b's "peg is global, full stop" is superseded.
 *
 * (D-a/D-b, docs/ai-credits-console-refactor-plan.md §2.1-2.5):
 *
 *     credits = provider_cost_usd / ai_credit_peg_usd
 *
 * Required:
 *   ai_credit_peg_usd (string) — decimal string, e.g. '0.00040000'. Must be > 0 —
 *     a zero or negative peg would divide-by-zero the entire credit computation,
 *     so it is rejected here, at the contract boundary, not downstream.
 */
import { registerContract } from './validate'

export interface AiCredits_PegInput {
ai_credit_peg_usd: string
}

registerContract('AiCredits_PegInput', {
  ai_credit_peg_usd: { type: 'string',  required: true },
})
